import React from 'react';
import './Home.css';
import { Link} from "react-router-dom";


class Home extends React.Component {
    render () {
      return (
        <div className="home jumbotron jumbotron-fluid">
          <div className="caption text-dark">
            <span>Ladang Shop</span>
            <p className="text-center">-Beli, Infaq dan Shadaqah untuk kepentingan dakwah dan umat-</p>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3  col-sm-3 col-6">
                <Link to="/tentang">
                  <div className="content mx-auto shadow">
                    <i className="fa fa-users" aria-hidden="true"></i>
                    <h5>Tentang Kami</h5>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-6">
                <Link to="/beli">
                  <div className="content mx-auto shadow">
                    <i className="fa fa-cart-plus" aria-hidden="true"></i>
                    <h5>Beli Product</h5>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-6">
                <Link to="/cara">
                  <div className="content mx-auto shadow">
                    <i className="fa fa-handshake-o" aria-hidden="true"></i>
                    <h5>Cara Pembelian</h5>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-6">
                <Link to="/kontak">
                  <div className="content mx-auto shadow">
                    <i className="fa fa-address-card" aria-hidden="true"></i>
                    <h5>Kontak Kami</h5>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }


export default Home;
